import { render, staticRenderFns } from "./EVCurrentData.vue?vue&type=template&id=957f2348&"
import script from "./EVCurrentData.vue?vue&type=script&lang=js&"
export * from "./EVCurrentData.vue?vue&type=script&lang=js&"
import style0 from "./EVCurrentData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports